// export const getUserUid = (state) => state.user
export const getUser = (state) => state.user
export const getIsAuth = (state) => !!getUser(state).authToken
export const getUserData = (state) => state.user.userData
